var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('div', {
    class: _vm.$style.logo,
    on: {
      "click": _vm.handleClickToEditProject
    }
  }, [_c('project-logo', {
    attrs: {
      "project": _vm.project,
      "size": "lg"
    }
  })], 1), _c('div', {
    class: _vm.$style.section
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 5,
      expression: "5"
    }],
    class: _vm.$style.title
  }, [_c('h1', {
    directives: [{
      name: "cursor",
      rawName: "v-cursor",
      value: _vm.isPersonalProject ? 'pointer' : 'default',
      expression: "isPersonalProject ? 'pointer' : 'default'"
    }],
    domProps: {
      "textContent": _vm._s(_vm.project.name)
    },
    on: {
      "click": _vm.handleClickToEditProject
    }
  }), _vm.project.safeDeal ? _c('project-safe-deal', {
    directives: [{
      name: "m-l",
      rawName: "v-m-l",
      value: 10,
      expression: "10"
    }, {
      name: "d-flex",
      rawName: "v-d-flex"
    }],
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e()], 1), _c('a', {
    directives: [{
      name: "opacity",
      rawName: "v-opacity",
      value: .5,
      expression: ".5"
    }],
    class: _vm.$style.link,
    attrs: {
      "href": _vm.project.link,
      "target": "_blank",
      "rel": "noopener nofollow"
    },
    domProps: {
      "textContent": _vm._s(_vm.projectLink)
    }
  })])]), _vm.isPersonalProject ? _c('div', {
    class: _vm.$style.navigation
  }, [_vm.isActiveRecurrent ? _c('subscribers-counter-text', {
    directives: [{
      name: "cursor",
      rawName: "v-cursor:pointer",
      arg: "pointer"
    }],
    attrs: {
      "subscriber-count": _vm.project.subscriberCount
    },
    on: {
      "click": _vm.handleClickToSubscriptions
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.payout
  }, [_c('simple-button', {
    attrs: {
      "variant": "pinky",
      "disabled": _vm.isInactiveProject
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'payout'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.displayBalance) + " ")])], 1)], 1) : _vm.isPartnerProject ? _c('div', {
    class: _vm.$style.badge,
    domProps: {
      "textContent": _vm._s(_vm.$t('common.partner'))
    }
  }) : _vm._e()]), _vm.$slots.hasOwnProperty('graph') ? _c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 20,
      expression: "20"
    }]
  }, [_vm._t("graph")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }